import { Link } from '@remix-run/react'
import { ArrowRight } from 'lucide-react'
import { type SerializableSection } from './categorizeSection'

export function SectionList({
  sections,
  day,
}: {
  sections: SerializableSection[]
  day: string
}) {
  return (
    <ul className="mt-2 space-y-1">
      {sections.map(section => (
        <li key={section.id} className="pl-4 text-sm">
          <Link
            to={`/hansard/${day}/section/${section.id}`}
            className="flex items-center text-primary underline-offset-4 hover:underline"
          >
            {section.title}
            <ArrowRight className="ml-1 h-3 w-3" />
          </Link>
        </li>
      ))}
    </ul>
  )
}
